import DataRoomWithdraw from './DataRoomWithdraw.component';

export default DataRoomWithdraw;